import { WorkspaceSubscriptionAccountTrustEventRecord } from '../../../../../../../../server-services/query-records/workspace-records';
import { WorkspaceChangeSubscriptionSpecificHandler } from '../types';

export let onCreateAccountTrustEventSubscriptionHandler: WorkspaceChangeSubscriptionSpecificHandler =
  (cache, event: WorkspaceSubscriptionAccountTrustEventRecord) => {};
